import { ApolloError } from '@apollo/client';

import {
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  LoadedContent,
  LinearProgress,
  Pagination,
  IPaginationProps,
} from '@occc/ui-design-system';
import { Box } from '@occc-app/design-system';
import { ScanDataMissingStoresDetailsFragment } from '@occc/graphql';

type ScanDataMissingStoresTableProps = {
  data?: ScanDataMissingStoresDetailsFragment[];
  loading: boolean;
  error?: ApolloError;
  paginationProps: IPaginationProps;
};

export const ScanDataMissingStoresTable = ({
  data,
  loading,
  error,
  paginationProps,
}: ScanDataMissingStoresTableProps) => {
  const renderData = (items: ScanDataMissingStoresDetailsFragment[]) => {
    return (
      <>
        {loading && <LinearProgress />}
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>Site ID</TableCell>
              <TableCell>Site Name</TableCell>
              <TableCell>Site Address</TableCell>
              <TableCell>Phone Number</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {items.map((store) => (
              <TableRow key={store.siteID}>
                <TableCell>{store.siteID}</TableCell>
                <TableCell>{store.siteName}</TableCell>
                <TableCell>{store.siteAddress}</TableCell>
                <TableCell>{store.phoneNumber || '-'}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
        <Box display='flex' justifyContent='flex-end'>
          <Pagination {...paginationProps} />
        </Box>
      </>
    );
  };

  return <LoadedContent items={data} loading={loading} error={error} renderData={renderData} />;
};
